var _mask, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassOffLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "lineMdCompassOffLoop0"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 64,
    strokeDashoffset: 64,
    d: "M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9Z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    dur: "0.6s",
    values: "64;0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    d: "M11 11L12 12L13 13L12 12z",
    transform: "rotate(-180 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0.6s",
    dur: "0.3s",
    values: "M11 11L12 12L13 13L12 12z;M10.2 10.2L17 7L13.8 13.8L7 17z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "9s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "-180 12 12;0 12 12;0 12 12;0 12 12;0 12 12;270 12 12;-90 12 12;0 12 12;-180 12 12;-35 12 12;-40 12 12;-45 12 12;-45 12 12;-110 12 12;-135 12 12;-180 12 12"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1,
    fill: "#000",
    fillOpacity: 0,
    stroke: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "0.9s",
    dur: "0.15s",
    values: "0;1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeDasharray: 28,
    strokeDashoffset: 28,
    d: "M-1 11h26",
    transform: "rotate(45 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "1.05s",
    dur: "0.4s",
    values: "28;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 28,
    strokeDashoffset: 28,
    d: "M-1 13h26",
    transform: "rotate(45 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "1.05s",
    dur: "0.4s",
    values: "28;0"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    mask: "url(#lineMdCompassOffLoop0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassOffLoop);
export default __webpack_public_path__ + "static/media/compass-off-loop.0c25dd4f854b61ac3f9600b6fcad5b35.svg";
export { ForwardRef as ReactComponent };